import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../common/service.base';
import { AppConfig } from '../configuration/app.config';
import { AuthService } from '../services/auth.service';

class CreateClientLogEntryRequest {
  message: string;
  details: string;
}

class CreateClientLogEntryResponse {
  reference: string;
}

@Injectable()
export class ClientLogService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig
  ) {
    super(
      'v1',
      'clientlog',
      authService,
      config.BFFSConfig
    );
  }

  public async create(message: string, details: string): Promise<string> {
    return (await super.post<CreateClientLogEntryResponse>({ message, details } as CreateClientLogEntryRequest, null, "create")).reference;
  }

  public async isServiceAvailable(): Promise<boolean> {
    return await super.isServiceAvailable();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/client.log.service.ts